import React from 'react';
import BusinessCard from './BusinessCard';

const CardGrid = ({ profiles, onCardClick }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {profiles.map(profile => (
        <BusinessCard 
          key={profile.id} 
          profile={profile} 
          onCardClick={onCardClick}
        />
      ))}
    </div>
  );
};

export default CardGrid;
